import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { PendingCheckoutDialog } from 'features/iam/components/seats/pending-checkout-action';
import { usePlanSeats } from '../hooks/use-seats';

const PendingPayment = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { planSeats } = usePlanSeats();
  const entry = planSeats.find((candidate) => candidate.pool && candidate.awaitingPayment);
  if (!entry) return null;

  return (
    <>
      <div className="flex shrink-0 items-center gap-2 rounded-full border border-orange-200 bg-orange-50 py-1 pl-3 pr-1 dark:border-orange-500/40 dark:bg-orange-500/10">
        <span className="h-2 w-2 shrink-0 rounded-full bg-orange-500" aria-hidden="true" />
        <span className="hidden text-xs font-semibold leading-4 text-orange-700 dark:text-orange-300 sm:inline">
          {t('PAYMENT_PENDING', 'Payment pending')}
        </span>
        <Button
          size="sm"
          className="h-7 rounded-full !bg-warning px-3 text-xs font-semibold !text-white hover:opacity-90"
          onClick={() => setIsOpen(true)}
        >
          {t('PAY_NOW', 'Pay now')}
        </Button>
      </div>
      <PendingCheckoutDialog entry={entry} open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};

/**
 * Shown in the header while a plan the organization bought waits for its first payment. Pay now
 * opens the same choice as the plan card: continue checkout, or cancel the plan.
 * Members without the admin role cannot pay for plans, so they never see it.
 */
export const PendingPaymentBadge = () => {
  const isOnlyOrgUser = useCommonStore((s) => s.isOnlyOrgUser);
  if (isOnlyOrgUser) return null;
  return <PendingPayment />;
};
